import * as React from "react";
import { HudButtonFortuneTellerEvent } from "../../fortune-teller-event/components/HudButtonFortuneTellerEvent";
import { HudButtonPurchasePointsEvent } from "../../purchase-points-event/components/HudButtonPurchasePointsEvent";
import { HudButtonTraderEvent } from "../../trader-event/components/HudButtonTraderEvent";
export var BF2HudRight = function () { return (React.createElement(React.Fragment, null,
    React.createElement(HudButtonPurchasePointsEvent, null),
    React.createElement(HudButtonTraderEvent, null),
    React.createElement(HudButtonFortuneTellerEvent, null))); };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/hud/BF2HudRight.tsx
// module id = 2293
// module chunks = 3